import Wrapper from "./style"

export const Card = ({ thumbnail, displayName, description, siteUrl, thumbnailMimetype }) => {
    return (
        <Wrapper href={siteUrl}>
            <img
                className="image"
                src={`data:${thumbnailMimetype};base64,${thumbnail}`}
                alt="thumbnail"
            />
            <h2>{displayName}</h2>
            <p>{description}</p>
            <div className="bottom">
                <a href={siteUrl + "/DownloadData"} className="mds-small mds-arrow-link css-1k0cz4m">
                    <span title="#" className="css-14ypaib">Access data</span>
                    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" className="css-1x6cf84"><path fill="currentColor" d="M9.3 1.3L7.9 2.7 12.2 7H0v2h12.2l-4.3 4.3 1.4 1.4L16 8z"></path></svg>
                </a>
            </div>
        </Wrapper>
    )
}